import { render, staticRenderFns } from "./SetupHeader.vue?vue&type=template&id=97207f58&scoped=true"
import script from "./SetupHeader.vue?vue&type=script&lang=js"
export * from "./SetupHeader.vue?vue&type=script&lang=js"
import style0 from "./SetupHeader.vue?vue&type=style&index=0&id=97207f58&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97207f58",
  null
  
)

/* custom blocks */
import block0 from "./SetupHeader.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports